import React from 'react';
import { CheckIcon, XIcon } from 'lucide-react';
const without = ['Empty pages you still have to fill in', 'Videos you have to watch, learn and break down yourself', 'A monthly or yearly fee that never ends', 'Built for preschool, ballet technique or competition teams', 'You still decide what to teach on Monday'];
const withIt = ['A complete class for every week of the season, in order', 'Routines written in 8-counts you can print and take to class', 'Starter, Core and Stretch levels for mixed-age rooms', 'One payment — no subscription, no syllabus to sign up for', 'Open the week and teach'];
export function ValueStack() {
  return <section aria-labelledby="vs-heading" className="w-full bg-white" data-id="element-323" data-mp="295e6x1uowlpx">
      <div className="max-w-4xl mx-auto px-5 py-16 sm:py-20" data-id="element-324" data-mp="2d6zimjvhmtyj">
        <div className="text-center" data-id="element-325" data-mp="30y4vcq64t64m">
          <p className="text-[11px] font-semibold uppercase tracking-[1.8px] text-coral-deep" data-id="element-326" data-mp="30x3mmscl8vq2">
            Why this isn&apos;t another lesson-plan PDF
          </p>
          <h2 id="vs-heading" className="mt-3 font-display font-bold text-plum text-3xl sm:text-5xl" data-id="element-327" data-mp="1tgekc26d7sus">
            Blank templates vs{' '}
            <span className="text-coral-deep" data-id="element-328" data-mp="234wiebn9fluq">a planned season</span>
          </h2>
          <p className="mx-auto mt-4 max-w-2xl text-base text-ink-soft" data-id="element-329" data-mp="1yeg30lzvpq5q">
            Most resources for dance teachers sell you a blank planner, a short
            preschool curriculum or a video library with a yearly fee. Having
            ideas was never the only hard part — turning them into a class for
            20 mixed-age kids, every single week, was.
          </p>
        </div>

        {/* Two columns at every width — never stacks */}
        <div className="mt-8 grid grid-cols-2 overflow-hidden rounded-3xl border border-cream-dark" data-id="element-330" data-mp="2h68x6jqophf1">
          <div className="bg-cream px-3.5 py-4 sm:p-6" data-id="element-331" data-mp="rqspl8ses3r9">
            <h3 className="font-display text-base font-bold text-ink-soft sm:text-xl" data-id="element-332" data-mp="mr698qhaa7e8">
              A blank planner or a video subscription
            </h3>
            <ul className="mt-3.5 grid gap-2.5" data-id="element-333" data-mp="2mv0gwclty8z9">
              {without.map(item => <li key={item} className="flex items-start gap-2 text-[12.5px] leading-snug text-ink-soft sm:text-sm" data-id="element-334" data-mp="2rsshrw4gd5fl">
                  <span className="mt-0.5 flex h-4 w-4 flex-none items-center justify-center rounded-full bg-coral/15" data-id="element-335" data-mp="30t73gwlbwmjm">
                    <XIcon className="h-2.5 w-2.5 text-coral-deep" aria-hidden="true" data-id="element-336" data-mp="35rigfg6x7d62" />
                  </span>
                  {item}
                </li>)}
            </ul>
          </div>
          <div className="bg-plum px-3.5 py-4 text-white sm:p-6" data-id="element-337" data-mp="3jjyee2kysl04">
            <h3 className="font-display text-base font-bold text-gold sm:text-xl" data-id="element-338" data-mp="3jl9ensf7bamh">
              Dance Class Ready
            </h3>
            <ul className="mt-3.5 grid gap-2.5" data-id="element-339" data-mp="3tgt90ae4a194">
              {withIt.map(item => <li key={item} className="flex items-start gap-2 text-[12.5px] font-medium leading-snug sm:text-sm" data-id="element-340" data-mp="7gokg9qpkaow">
                  <span className="mt-0.5 flex h-4 w-4 flex-none items-center justify-center rounded-full bg-gold/20" data-id="element-341" data-mp="2jezp7e9kn7e">
                    <CheckIcon className="h-2.5 w-2.5 text-gold-hover" aria-hidden="true" data-id="element-342" data-mp="3pm1my341tw51" />
                  </span>
                  {item}
                </li>)}
            </ul>
          </div>
        </div>
      </div>
    </section>;
}